import { isDate } from 'date-fns';

import { displayDate, VALID_DATE_FORMATS } from '@adsk/alloy-react-datetime';

export const rawDateFormatter = (date: number | Date) =>
  displayDate(isDate(date) ? date : new Date(date), {
    format: VALID_DATE_FORMATS.SHORT,
  });

export const dateFormatter = ({
  date,
  isActual,
}: {
  date?: string | null;
  isActual?: boolean;
}) => {
  if (!date) return '';
  return `${rawDateFormatter(new Date(date))} ${isActual ? 'A' : ''}`.trim();
};

export function formatFloatProgress(progress: number) {
  return Math.floor(progress * 100);
}
